import { Injectable } from '@angular/core';

import { BehaviorSubject, timer } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {
  notifications$ = new BehaviorSubject<ToastNotification[]>([]);

  show(type: ToastNotificationType, message: string, options?: ToastNotificationOptions): void {
    const id = Math.floor(Math.random() * 100000);
    const notifications = this.notifications$.getValue();
    const duration = options?.duration ?? 3500;
    const permanent = options?.permanent ?? false;

    // Create a new notification
    notifications.push({
      id,
      message,
      type,
      className: '',
      duration,
      permanent,
      closeFn: () => this.removeNotificationByID(id),
      ...options
    });

    this.notifications$.next(notifications);

    // remove notification after duration
    if (!permanent) {
      timer(duration)
        .pipe(take(1))
        .subscribe(() => {
          this.removeNotificationByID(id);
        });
    }
  }

  removeAll(): void {
    this.notifications$.next([]);
  }

  private removeNotificationByID(id: number) {
    this.notifications$.next(this.notifications$.getValue().filter((item) => item.id !== id));
  }
}

type ToastNotificationType = 'success' | 'critical' | 'info' | 'warning';

export interface ToastNotification {
  id: number;
  className: string;
  type: ToastNotificationType;
  message: string;
  duration: number;
  permanent: boolean;
  closeFn();
}

export interface ToastNotificationOptions {
  className?: string;
  duration?: number;
  permanent?: boolean;
}
